import ArtistAccountTabs from "@/components/ArtistAccountTabs";
import CurrentUserDrawer from "@/components/CurrentUserDrawer";
import { Close } from "@mui/icons-material";
import { AppBar, Box, IconButton, Toolbar } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import SongsTable from "./SongsTable";

export default function Portal() {
  const { artistKey } = useParams();

  return (
    <Box>
      <PageAppBar artistKey={artistKey} />
      <ArtistAccountTabs />
      <Box
        sx={{
          pl: { xs: 1, lg: "220px" },
          pr: { xs: 1, lg: 2 },
          pt: { xs: 9, lg: 10 },
          pb: { xs: "100px", lg: 4 },
        }}
      >
        <SongsTable />
      </Box>
    </Box>
  );
}

function PageAppBar({ artistKey }) {
  const navigate = useNavigate();
  return (
    <AppBar
      position="fixed"
      elevation={0}
      style={{ background: "rgba(19,19,19,.9)" }}
    >
      <Toolbar
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <IconButton onClick={() => navigate(`/${artistKey}`)}>
          <Close />
        </IconButton>

        {/* <Box sx={{ display: "flex", alignItems: "center" }}>
          <NotebookIcon size={24} />
          <Typography
            style={{
              fontFamily: "'Montserrat Alternates', sans-serif",
              fontWeight: 700,
              fontSize: "1.8rem",
              marginLeft: "12px",
            }}
          >
            songs
          </Typography>
        </Box> */}

        <CurrentUserDrawer />
      </Toolbar>
    </AppBar>
  );
}
